import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getCin7OmniReturnsSettings = {
  name: "getCin7OmniReturnsSettings" as const,
  input: z.object({}),
  output: z.object({
    settings: z
      .object({
        id: zExt.objectId(),
        baseUrl: z.string().nullable().optional(),
        enabled: z.boolean(),
        createReturnsEnabled: z.boolean(),
        processReturnsEnabled: z.boolean(),
        returnTypeCustomFieldKey: z.string().nullable().optional(),
        compensationMethodCustomFieldKey: z.string().nullable().optional(),
        creditNoteCustomFields: z.array(
          z.object({ fieldKey: z.string(), fieldValue: z.string() }),
        ),
      })
      .nullable(),
  }),
};
